import { Checkbox } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';
import { MedicalLeaveCommonFormController } from '../../common.types';
import { MedicalLeaveFormSectionColumn } from '../../MedicalLeaveFormSectionColumn/MedicalLeaveFormSectionColumn';

import { StyledMedicalLeaveFormCodesCheckboxes } from './StyledMedicalLeaveFormCodesCheckboxes';
import { CODES } from './workInability.constants';

type MedicalLeaveFormCodesProps = {
   readonly controller: MedicalLeaveCommonFormController;
};

const MedicalLeaveFormCodes = (props: MedicalLeaveFormCodesProps): JSX.Element => (
   <MedicalLeaveFormSectionColumn title={commonTranslationKeys.codes}>
      <StyledMedicalLeaveFormCodesCheckboxes>
         {CODES.map((code) => (
            <Checkbox
               key={code}
               controller={props.controller.register(`code${code}`)}
               label={commonTranslationKeys[`code${code}` as const]}
               testId={code}
            />
         ))}
      </StyledMedicalLeaveFormCodesCheckboxes>
   </MedicalLeaveFormSectionColumn>
);

export { MedicalLeaveFormCodes };
